import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const { urlToken } = useParams();
  const { joinMemberToken, splitToken, crypt, setMemberCore } =
    useContext(valueContext);
  let token = "";

  const { formDataFunc } = useApiFunction();
  const [showotp, setShowOtp] = useState(false);
  const [data, setData] = useState({
    userName: "",
    tId: "",
    address: "",
    otp: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [submitLoading, setSubmitLogin] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    const res = await formDataFunc(
      `member/get_member`,
      JSON.stringify({}),
      "POST",
      token
    );
    if (res.status) {
      console.log(res.msg);
      setData({
        userName: res.msg.userName,
        tId: res.msg.twlUserName ? res.msg.twlUserName : "---",
        address: res.msg.address ? res.msg.address : ""
      });
      setMemberCore(res.msg.core);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      window.localStorage.removeItem("A_");
      window.localStorage.removeItem("B_");
      window.localStorage.removeItem("C_");
      navigate("/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg);
    }
    setIsLoading(false);
  };

  const submit = async e => {
    setSubmitLogin(true);
    token = joinMemberToken();
    const res = await formDataFunc(
      `member/send_withdrawal_addr_edit_otp`,
      JSON.stringify({}),
      "POST",
      token
    );
    if (res.status) {
      setShowOtp(true);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      window.localStorage.removeItem("A_");
      window.localStorage.removeItem("B_");
      window.localStorage.removeItem("C_");
      navigate("/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg);
    }
    setSubmitLogin(false);
  };

  const submitAddress = async () => {
    setSubmitLogin(true);
    if (data.address === "" || data.otp === "") {
      toast.warning("Please Fill address or otp for update address");
      setSubmitLogin(false)
    } else {
      token = joinMemberToken();
      const body = JSON.stringify({
        address: data.address,
        otp: data.otp
      });
      const res = await formDataFunc(
        `member/verify_otp_and_update_address`,
        body,
        "POST",
        token
      );
      if (res.status) {
        setShowOtp(false);
        toast.success(res.msg);
      } else if (
        res.error &&
        (res.error === "ERROR_TOKEN_INVALID0" ||
          res.error === "ERROR_TOKEN_INVALID1" ||
          res.error === "user not registered" ||
          res.error === "ERROR_TOKEN_INVALID2" ||
          res.error === "ERROR_TOKEN_INVALID3" ||
          res.error === "unauthorized" ||
          res.error === "Your session has expierd Please login again 1" ||
          res.error === "Your session has expierd Please login again 2")
      ) {
        window.localStorage.removeItem("A_");
        window.localStorage.removeItem("B_");
        window.localStorage.removeItem("C_");
        navigate("/login");
      } else if (res.error) {
        toast.warning(res.error, { autoClose: 2000 });
      } else if (res.msg === "Your OTP is expired") {
        setShowOtp(false);
      } else {
        toast.warning(res.msg);
      }
      setSubmitLogin(false);
    }
  };
  const Handle = async e => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (!urlToken) {
      token = joinMemberToken();
      getData();
    } else {
      token = splitToken(urlToken);
      const encrypted_textA = crypt("salt", token.textA);
      const encrypted_textB = crypt("salt", token.textB);
      const encrypted_textC = crypt("salt", token.textC);
      window.localStorage.setItem("A_", encrypted_textA);
      window.localStorage.setItem("B_", encrypted_textB);
      window.localStorage.setItem("C_", encrypted_textC);
      token = joinMemberToken();

      navigate("/");
    }
  }, [urlToken]);
  useEffect(() => {
    if (location?.state?.msg) {
      toast.success(location.state.msg, { autoClose: 2000 });
    }
  }, [location]);
  return (
    <>
      {data ? (
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-18">Profile</h4>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-8">
                  <div className="card profile-section">
                    <div className="card-body">
                      <div className="col-lg-12 col-md-12 col-sm-6">
                        <form>
                          <div className="form-group mb-3">
                            <label
                              for=""
                              className="sub-heading col-form-label"
                            >
                              UserName
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="username"
                              value={data.userName}
                              name="userName"
                              readOnly
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label
                              for=""
                              className="sub-heading col-form-label"
                            >
                              T-Life ID
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="T-Life Id"
                              value={data.tId}
                              name="tId"
                              readOnly
                            />
                          </div>

                          {showotp ? (
                            <>
                              <div className="form-group mb-3">
                                <label
                                  for=""
                                  className="sub-heading col-form-label"
                                >
                                  Address
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Address"
                                  name="address"
                                  value={data.address ? data.address : ""}
                                  onChange={e => {
                                    Handle(e);
                                  }}
                                />
                              </div>
                              <div className="form-group mb-3">
                                <label
                                  for=""
                                  className="sub-heading col-form-label"
                                >
                                  Otp
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter otp"
                                  name="otp"
                                  value={data.otp ? data.otp : ""}
                                  onChange={e => {
                                    Handle(e);
                                  }}
                                />
                              </div>
                              <div className="mt-3">
                                <button
                                  className="block-menu"
                                  disabled={submitLoading}
                                  type="button"
                                  onClick={() => submitAddress()}
                                >
                                  {submitLoading && (
                                    <i
                                      className="bx bx-loader-circle rotating"
                                      style={{ marginRight: "5px" }}
                                    />
                                  )}
                                  Edit
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="form-group mb-3">
                                <label
                                  for=""
                                  className="sub-heading col-form-label"
                                >
                                  Address
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Address"
                                  name="address"
                                  value={data.address ? data.address : ""}
                                  readOnly
                                />
                              </div>
                              <div className="mt-3">
                                <p style={{ color: "red" }}>
                                  Send Otp for update withdrawal address
                                </p>
                                <button
                                  className="block-menu"
                                  disabled={submitLoading}
                                  type="button"
                                  onClick={e => submit(e)}
                                >
                                  {submitLoading && (
                                    <i
                                      className="bx bx-loader-circle rotating"
                                      style={{ marginRight: "5px" }}
                                    />
                                  )}
                                  send Otp
                                </button>
                              </div>
                            </>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <h1>Loading</h1>
      )}
      <ToastContainer />
    </>
  );
}

export default Profile;
